import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { Box, ClickAwayListener, Popper, IconButton, Tab, Tabs, Grid, Button } from "@mui/material";
import { TabContext, TabList, TabPanel } from '@mui/lab'

import { ReactComponent as FilterIcon } from "../../assets/icons/icon_filter.svg";
import FilterTabPanel from "./FilterTabPanel";

const ReportFilterPopup = ({ query, updateQuery, reportDetails }) => {
    const [currentTab, setCurrentTab] = useState(null)
    const [filterPopupFlag, setFilterPopupFlag] = useState(false)
    const [filterList,setFilterList] = useState([])
    const [anchorEl, setAnchorEl] = useState(null);


    const showReportFilters = useCallback((event) => {
        setFilterPopupFlag(true)
        setAnchorEl(event.currentTarget)
    })

    const handleClose = useCallback(() => {
        setFilterPopupFlag(false)
        setAnchorEl(null)
    })

    const handleTabChange = useCallback((event, newValue) => {
        //console.log(newValue)
        setCurrentTab(newValue)
    })

    const getCascadedWithVal = useCallback((fieldName) => {
        if(fieldName){
            let parentFilter = filterList.find(obj => obj.member === fieldName && obj.onReport && obj.operator === 'equals')
            if(parentFilter){
                if(parentFilter.values && parentFilter.values.length > 0){
                    return true
                }else{
                    return false
                }
            }else{
                return true
            }
        }else{
            return true
        }
    })

    const clearReportFilters = useCallback(() =>{
        let list = filterList.map(obj => {
            if(obj.onReport){
                obj.values = []
            }
            return obj
        })
        let filters = reportDetails.filters.filter(obj => !obj.onReport).map(obj => {
            return {
                member: obj.member,
                operator: obj.operator.split('#')[0],
                values: obj.values
            }
        })
        setFilterList(list)
        updateQuery({filters:filters})
        handleClose()
    })

    const applyReportFilter = useCallback(() =>{
        let customFilters = reportDetails.filters.filter(obj => obj.values.length > 0).map(obj => {
            return {
                member: obj.member,
                operator: obj.operator.split('#')[0],
                values: obj.values
            }
        })
        updateQuery({filters:[...customFilters]})
        handleClose()
    })

    useEffect(() => {
        let filterList = reportDetails.filters.filter(obj => obj.onReport)
        //console.log(filterList)
        let list = filterList.filter(obj => !obj.cascadedWith)
        if(list.length > 0){
            let currentTab = `${list[0].member}-filter-tab`
            setCurrentTab(currentTab)
        }        
        setFilterList(filterList)
    },[reportDetails.filters])

    return <ClickAwayListener onClickAway={handleClose}>
        <Box sx={{ position: 'relative', justifyContent: 'flex-end', textAlign: 'right' }}>
            <IconButton disabled={false} className="form-icon-btn" size="small" onClick={showReportFilters}> <FilterIcon /> </IconButton>
            <Popper
                open={filterPopupFlag}
                anchorEl={anchorEl}
                id="long-menu"
                onClose={e => handleClose(false)}
                placement='bottom-end'
                popperOptions={{ positionFixed: true }}
                sx={{
                    minWidth: 100, maxHeight: '400px', overflow: 'visible', boxShadow: '0 0 4px #00000029', borderRadius: '8px', zIndex: 9
                }}
            >
                <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: 400, borderRadius: '8px' }} >
                    {
                        currentTab &&
                        <TabContext value={currentTab?.toString()}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList className='report-chart-filter-menu dash-report-filters-tabs' variant="fullWidth" orientation="vertical" onChange={handleTabChange} aria-label="lab API tabs example">
                                    {
                                        filterList && filterList.length > 0 && filterList.sort((a,b) => a.orderPriority - b.orderPriority).map((obj, index) => (
                                            <Tab className={`report-chart-filter-menuitem ${getCascadedWithVal(obj.cascadedWith) ? '':'tab-disabled'}`} key={`${index}-filter-tab-${obj.member}`} label={obj.displayName} value={`${obj.member}-filter-tab`} />
                                        ))
                                    }
                                </TabList>
                            </Box>
                            {
                                filterList && filterList.length > 0 && filterList.sort((a,b) => a.orderPriority - b.orderPriority).map((obj, index) => (
                                    <TabPanel key={`${index}-filter-tabpanel-${obj.member}`} value={`${obj.member}-filter-tab`}>
                                        <FilterTabPanel
                                            query={query}
                                            filterObj={obj}
                                            filterIndex={index}
                                            filterList={filterList}
                                            updateFilter={setFilterList}
                                        />
                                    </TabPanel>
                                ))
                            }
                        </TabContext>
                    }
                    <Grid>
                        <Box sx={{ mt: 2 }} display="flex" justifyContent={'center'}>
                            <Button onClick={clearReportFilters} className="report_form_ui_btn primary text-btn-small mr-2" variant="contained" color="primary" >Clear</Button>
                            <Button onClick={applyReportFilter} className="report_form_ui_btn primary text-btn-small mr-2" variant="contained" color="primary" >Apply</Button>
                        </Box>
                    </Grid>
                </Box>
            </Popper>
        </Box>
    </ClickAwayListener>
}

export default memo(ReportFilterPopup)